import { type SearchClient } from 'algoliasearch';

import { algoliasearchWithControl } from '@/integrations/algolia/searchWithControl';
import { PAGE_CONTEXT } from '@/integrations/algolia/types';
import {
  ALGOLIA_APP_ID,
  ALGOLIA_OFFLINE_MODE,
  ALGOLIA_SSR_API_KEY,
} from '@/lib/const';
import { eyewearFakePlpData } from '@/testUtils/fixtures/eyewear';
import { watchesFakePlpData } from '@/testUtils/fixtures/watches';

export const algoliaSsrSearchClient = algoliasearchWithControl(
  ALGOLIA_APP_ID,
  ALGOLIA_SSR_API_KEY,
);

const buildMockSearchResult = (mockResponse: any) => ({
  hits: mockResponse.hits,
  nbHits: mockResponse.nbHits,
  nbPages: mockResponse.nbPages,
  page: 0,
  processingTimeMS: 0,
  hitsPerPage: 20,
  exhaustiveNbHits: false,
  query: '',
  params: '',
  facets: mockResponse.facets,
});

export const createMockSearchClientSSR = (mockResponse: any) => {
  const client = algoliasearchWithControl(ALGOLIA_APP_ID, ALGOLIA_SSR_API_KEY);
  return {
    ...client,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    search(requests: any) {
      return Promise.resolve({
        results: requests.map(() => buildMockSearchResult(mockResponse)),
      });
    },
    initIndex(indexName: string) {
      const index = client.initIndex(indexName);
      return {
        ...index,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        search(query: string, requestOptions: any) {
          return Promise.resolve(buildMockSearchResult(mockResponse));
        },
      };
    },
  } as SearchClient;
};

export const createSsrSearchClient = (pageContext: PAGE_CONTEXT) => {
  const disconnected = ALGOLIA_OFFLINE_MODE ?? false;
  if (disconnected) {
    if (pageContext === PAGE_CONTEXT.PLP_WATCHES) {
      return createMockSearchClientSSR(watchesFakePlpData);
    }
    if (pageContext === PAGE_CONTEXT.PLP_EYEWEAR) {
      return createMockSearchClientSSR(eyewearFakePlpData);
    }
    // @TODO: add more as needed
  }
  return algoliaSsrSearchClient;
};
